import type { FeedbackTag, FeedbackTagCategory } from 'app/ui/components/molecules/workout-feedback/feedback-tags';

export const MAX_STAR_RATING_FOR_FRICTION = 3;
export const FREE_TEXT_MAX_LENGTH = 500;
export const SUCCESS_AUTO_DISMISS_MS = 1500;

export type RunAgainAnswer = 'YES' | 'NO';

export type FeedbackStep = 'ratings' | 'gym' | 'programming' | 'whiteboard' | 'free-text';

export interface FeedbackStepTracker {
  current: number;
  total: number;
}

export const getFeedbackStepTracker = (step: FeedbackStep): FeedbackStepTracker | null => {
  switch (step) {
    case 'gym':
      return { current: 2, total: 4 };
    case 'programming':
      return { current: 3, total: 4 };
    case 'whiteboard':
      return { current: 4, total: 4 };
    default:
      return null;
  }
};

export interface WorkoutFeedbackPayload {
  overallRating: number | null;
  easeOfFollowing: number | null;
  runAgain: RunAgainAnswer | null;
  feedbackTags: FeedbackTag[];
  freeText: string | null;
  skipped: boolean;
}

export interface WorkoutFeedbackLabels {
  title: string;
  overallRatingLabel: string;
  easeOfFollowingLabel: string;
  runAgainLabel: string;
  ratingValueLabel: (value: number) => string;
  easeRatingValueLabel: (value: number) => string;
  yes: string;
  no: string;
  next: string;
  back: string;
  submit: string;
  selectAllThatApply: string;
  stepIndicatorLabel: (current: number, total: number) => string;
  categoryQuestionLabel: (category: FeedbackTagCategory) => string;
  tagLabel: (tag: FeedbackTag) => string;
  shareFeedbackLabel: string;
  freeTextPlaceholder: string;
  charCountLabel: (current: number, max: number) => string;
  successMessage: string;
  closeLabel: string;
}

interface FrictionInput {
  overallRating: number | null;
  easeOfFollowing: number | null;
  runAgain: RunAgainAnswer | null;
}

export const hasFeedbackFriction = ({ overallRating, easeOfFollowing, runAgain }: FrictionInput): boolean =>
  (typeof overallRating === 'number' && overallRating <= MAX_STAR_RATING_FOR_FRICTION) ||
  (typeof easeOfFollowing === 'number' && easeOfFollowing <= MAX_STAR_RATING_FOR_FRICTION) ||
  runAgain === 'NO';
